import styled, { css } from 'styled-components';

import { Typography } from '@trader/components';

export const TotalPl = styled(Typography)<{ $color: string }>`
  ${({ $color }) => css`
    color: ${$color};
  `};
`;
